import {FactoryID, RouteKey} from "../../model-factory/type-interface/ModelFactoryType";
import {getModelFactory} from "../../model-factory/ModelFactory";
import {PostStatus, PostType} from "../../manager/post/PostManager";
import {IRouteIDs} from "../../model-factory/type-interface/ModelFactoryInterface";
import {PostDataChoice, PostDataModel} from "../../data/subject/PostDataFactory";
import RouteModel from "../../model-factory/basic/route/RouteModel";
import RouteFactory from "../../model-factory/basic/route/RouteFactory";
import ModelFactoryModel from "../../model-factory/basic/ModelFactoryModel";
import {IStringObject} from "../../common/SimpleInterface";
import RouteChoice from "../../model-factory/basic/route/RouteChoice";
import DataChoice from "../../model-factory/basic/data/DataChoice";
import {NICounty} from "../../manager/GeneralManager";
import {slugToID} from "../../common/SiteHelper";

export class PostListRouteModel extends RouteModel
{

    navigationRouteKey: RouteKey = "post_list_route_id";
    allowUnknownIfEmpty:boolean = true;
    sourceDataModel:PostDataModel | null = null;
    doCreateChoicesFromSource:boolean = true;

    postType:PostType = null!;
    postStatus:PostStatus|null = null;
    organisationID:number = 0;
    postDataModel:PostDataModel = null!;
    isMyEdit:boolean = false;

    applyModelConditions()
    {
        super.applyModelConditions();

        this.postType = this.populateIDs.post_type!;
        this.organisationID = this.populateIDs.organisation_id ?? 0;
        this.isMyEdit = this.populateIDs.browse_route_id === "my_profile";
        this.postStatus = !this.isMyEdit ? (((this.populateIDs.post_status === "expired") || (this.populateIDs.post_status === "draft") || (this.populateIDs.post_status === "pending")) ? this.populateIDs.post_status : "publish") : null;
        this.postDataModel = getModelFactory().postData.getPostDataModel(this.postType, !!this.organisationID);
    }

    requireSourceDataModel(): PostDataModel | null
    {
        return getModelFactory().postData.getSharedDataModel(this.postType);
    }


    getSourceChoiceList(): DataChoice[]
    {
        const fromChoiceList =  super.getSourceChoiceList();

        let choiceList:PostDataChoice[] = [];
        for(let choice of fromChoiceList){
            if(!(choice instanceof PostDataChoice)){
                continue;
            }
            if(this.isMyEdit){
                const organisationID = choice.postType === "organisation" ? choice.postID : choice.organisationID;
                if(organisationID !== this.organisationID){
                    continue;
                }
            } else if(choice.postStatus !== this.postStatus){
                continue;
            }
            choiceList.push(choice);
        }
        return choiceList;
    }

    getDerivedModels(): ModelFactoryModel[]
    {
        const models =  super.getDerivedModels();
        if(!models.includes(this.postDataModel)){
            models.push(this.postDataModel);
        }
        return models;
    }


    applyChoice(choice: RouteChoice)
    {
        if(this.postStatus && (this.postStatus !== "publish")){
            choice.publicID = "";
        }
        super.applyChoice(choice);
        choice.derivedRouteIDs.post_id = parseInt(choice.id);
        choice.postDataChoice = this?.sourceDataModel?.choices[choice.id] ?? null;
        if(this.isMyEdit){
            choice.nextFactoryID = "post_entry_route";
        }
    }
}

export default class PostListRouteFactory extends RouteFactory
{

    id: FactoryID = "post_list_route";

    birth(id: FactoryID): PostListRouteModel
    {
        return new PostListRouteModel(id);
    }

    getValidParamKeys(routeIDs:IRouteIDs, params:IStringObject):string[]
    {
        return ["category", "post_status", "county"];
    }

    getAdditionalRouteIDs(routeIDs: IRouteIDs, params: IStringObject, hash: string, suppliedRouteIDs?: IRouteIDs|null): IRouteIDs
    {
        const additionalIDs = super.getAdditionalRouteIDs(routeIDs, params, hash, suppliedRouteIDs);

        if(suppliedRouteIDs?.category_id){
            additionalIDs.category_id = suppliedRouteIDs.category_id;
        } else if(params.category){
            additionalIDs.category_id = params.category;
        }

        if(suppliedRouteIDs?.post_status){
            additionalIDs.post_status = suppliedRouteIDs.post_status;
        } else if(params.post_status){
            additionalIDs.post_status = params.post_status as PostStatus;
        }

        if(suppliedRouteIDs?.county){
            additionalIDs.county = suppliedRouteIDs.county;
        } else if(params.county){
            additionalIDs.county = slugToID(params.county) as NICounty;
        }

        return additionalIDs;
    }

    getDefaultModel(postType:PostType|null, myEdit:boolean = false, postStatus:PostStatus|null = null): PostListRouteModel | null
    {

        postType = postType ?? "organisation";
        let routeIDs:IRouteIDs;

        if(!myEdit){

            let postStatusBrowseRouteID = ""
            if(postStatus === "expired"){
                postStatusBrowseRouteID = "archive"
            } else if(postStatus === "draft"){
                postStatusBrowseRouteID = "unpublished"
            } else if(postStatus === "pending"){
                postStatusBrowseRouteID = "pending"
            }
            if(postStatusBrowseRouteID){
                routeIDs = {
                    browse_route_id: postStatusBrowseRouteID,
                    post_status_route_id: postType.toString()
                }
            } else {
                routeIDs = {
                    browse_route_id: postType.toString()
                }
            }
        } else {
            if(postType === "organisation"){
                return null;
            }
            routeIDs = {
                browse_route_id: "my_profile",
                my_profile_route_id: postType,
                post_route_id: "list"
            }
        }
        return this.getDefaultModelWithRoute(routeIDs)! as PostListRouteModel;
    }
}